import { type ReactNode } from "react";
import { LDProvider } from "launchdarkly-react-client-sdk";

import { env } from "@/config/env";

/**
 * The signed-in context is set by `useLaunchDarklyFlagsResolved`, which also
 * reports when the evaluation for that identity is available.
 */
export function LaunchDarklyProvider({ children }: { children: ReactNode }) {
  if (!env.launchDarklyEnabled || !env.launchDarklyClientSideId) {
    return <>{children}</>;
  }

  return (
    <LDProvider clientSideID={env.launchDarklyClientSideId}>
      {children}
    </LDProvider>
  );
}
